export interface TokenInputChipRect {
  left: number;
  right: number;
  top: number;
  bottom: number;
}

export interface TokenInputPoint {
  x: number;
  y: number;
}

interface TokenInputRow {
  start: number;
  end: number;
  top: number;
  bottom: number;
}

const groupRows = (rects: TokenInputChipRect[]): TokenInputRow[] =>
  rects.reduce<TokenInputRow[]>((rows, rect, index) => {
    const row = rows.at(-1);

    if (row && rect.top < row.bottom && rect.bottom > row.top) {
      row.end = index + 1;
      row.top = Math.min(row.top, rect.top);
      row.bottom = Math.max(row.bottom, rect.bottom);
    } else {
      rows.push({ start: index, end: index + 1, top: rect.top, bottom: rect.bottom });
    }

    return rows;
  }, []);

const distanceToRow = (row: TokenInputRow, y: number): number => Math.max(row.top - y, y - row.bottom, 0);

const findRow = (rows: TokenInputRow[], y: number): TokenInputRow =>
  rows.reduce((nearest, row) => (distanceToRow(row, y) < distanceToRow(nearest, y) ? row : nearest));

const centreOf = (rect: TokenInputChipRect): number => (rect.left + rect.right) / 2;

export const caretIndexFromPoint = (rects: TokenInputChipRect[], point: TokenInputPoint): number => {
  const rows = groupRows(rects);
  const lastRow = rows.at(-1);

  if (!lastRow || point.y > lastRow.bottom) {
    return rects.length;
  }

  const row = findRow(rows, point.y);

  for (let index = row.start; index < row.end; index++) {
    if (centreOf(rects[index]) > point.x) {
      return index;
    }
  }

  return row.end;
};
